import * as types from '../mutation-types';

const state = {
  country: null,
  language: null,
  phoneCode: null,
  phoneNumber: null,
  clientType: 'driver',
  inn: null,
  vat: 0,
  firstName: null,
  lastName: null,
  // postAddress: null,
  additionalPostAddress: false,
  realPostAddressIndex: null,
  realPostAddressCity: null,
  realPostAddressStreet: null,
  realPostAddressHouse: null,
  realPostAddressBuilding: null,
  realPostAddressOffice: null,
  email: null,
  password: null,
  repeatPassword: null,
  returnUrl: null,
  cookie: null,
  smsCode: null,
  smsCodeValid: false,
  emailCode: null,
  emailCodeValid: false,
};

const getters = {
  country: (state) => state.country,
  language: (state) => state.language,
  phoneCode: (state) => state.phoneCode,
  phoneNumber: (state) => state.phoneNumber,
  inn: (state) => state.inn,
  vat: (state) => state.vat,
  clientType: (state) => state.clientType,
  firstName: (state) => state.firstName,
  lastName: (state) => state.lastName,
  // postAddress: state => state.postAddress,
  additionalPostAddress: (state) => state.additionalPostAddress,
  realPostAddressIndex: (state) => state.realPostAddressIndex,
  realPostAddressCity: (state) => state.realPostAddressCity,
  realPostAddressStreet: (state) => state.realPostAddressStreet,
  realPostAddressHouse: (state) => state.realPostAddressHouse,
  realPostAddressBuilding: (state) => state.realPostAddressBuilding,
  realPostAddressOffice: (state) => state.realPostAddressOffice,

  email: (state) => state.email,
  password: (state) => state.password,
  repeatPassword: (state) => state.repeatPassword,
  returnUrl: (state) => state.returnUrl,
  cookie: (state) => state.cookie,
  smsCode: (state) => state.smsCode,
  smsCodeValid: (state) => state.smsCodeValid,
  emailCode: (state) => state.emailCode,
  emailCodeValid: (state) => state.emailCodeValid,
  phoneNumberE164: (state) => `+${state.phoneCode}${state.phoneNumber}`,
};

const mutations = {
  [types.SET_COUNTRY](state, payload) {
    state.country = payload;
  },
  [types.SET_LANGUAGE](state, payload) {
    state.language = payload;
  },
  [types.SET_PHONE_CODE](state, payload) {
    state.phoneCode = payload.replace(/\D/g, '');
  },
  [types.SET_PHONE_NUMBER](state, payload) {
    state.phoneNumber = payload.replace(/\D/g, '');
  },
  [types.SET_CLIENT_TYPE](state, payload) {
    state.clientType = payload;
  },
  [types.SET_INN](state, payload) {
    state.inn = payload;
  },
  [types.SET_VAT](state, payload) {
    state.vat = payload;
  },
  [types.SET_FIRST_NAME](state, payload) {
    state.firstName = payload;
  },
  [types.SET_LAST_NAME](state, payload) {
    state.lastName = payload;
  },
  // [types.SET_POST_ADDRESS](state, payload) {
  //   state.postAddress = payload
  // },
  [types.SET_ADDITIONAL_POST_ADDRESS](state, payload) {
    state.additionalPostAddress = payload;
  },
  [types.SET_REAL_POST_ADDRESS_INDEX](state, payload) {
    state.realPostAddressIndex = payload;
  },
  [types.SET_REAL_POST_ADDRESS_CITY](state, payload) {
    state.realPostAddressCity = payload;
  },
  [types.SET_REAL_POST_ADDRESS_STREET](state, payload) {
    state.realPostAddressStreet = payload;
  },
  [types.SET_REAL_POST_ADDRESS_HOUSE](state, payload) {
    state.realPostAddressHouse = payload;
  },
  [types.SET_REAL_POST_ADDRESS_BUILDING](state, payload) {
    state.realPostAddressBuilding = payload;
  },
  [types.SET_REAL_POST_ADDRESS_OFFICE](state, payload) {
    state.realPostAddressOffice = payload;
  },
  [types.SET_EMAIL](state, payload) {
    state.email = payload;
  },
  [types.SET_PASSWORD](state, payload) {
    state.password = payload;
  },
  [types.SET_REPEAT_PASSWORD](state, payload) {
    state.repeatPassword = payload;
  },
  [types.SET_RETURN_URL](state, payload) {
    state.returnUrl = payload;
  },
  [types.SET_COOKIE](state, payload) {
    state.cookie = payload;
  },
  [types.SET_SMS_CODE](state, payload) {
    state.smsCode = payload;
  },
  [types.SET_SMS_CODE_VALID](state, payload) {
    state.smsCodeValid = payload;
  },
  [types.SET_EMAIL_CODE](state, payload) {
    state.emailCode = payload;
  },
  [types.SET_EMAIL_CODE_VALID](state, payload) {
    state.emailCodeValid = payload;
  },
};

const actions = {
  setCountry({ commit }, payload) {
    commit(types.SET_COUNTRY, payload);
  },
  setLanguage({ commit }, payload) {
    commit(types.SET_LANGUAGE, payload);
  },
  setPhoneCode({ commit }, payload) {
    commit(types.SET_PHONE_CODE, payload);
  },
  setPhoneNumber({ commit }, payload) {
    commit(types.SET_PHONE_NUMBER, payload);
  },
  setClientType({ commit }, payload) {
    commit(types.SET_CLIENT_TYPE, payload);
  },
  setInn({ commit }, payload) {
    commit(types.SET_INN, payload);
  },
  setVat({ commit }, payload) {
    commit(types.SET_VAT, payload);
  },
  setFirstName({ commit }, payload) {
    commit(types.SET_FIRST_NAME, payload);
  },
  setLastName({ commit }, payload) {
    commit(types.SET_LAST_NAME, payload);
  },
  // setPostAddress({commit}, payload) {
  //   commit(types.SET_POST_ADDRESS, payload)
  // },
  setAdditionalPostAddres({ commit }, payload) {
    commit(types.SET_ADDITIONAL_POST_ADDRESS, payload);
  },
  setRealPostAddressIndex({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_INDEX, payload);
  },
  setRealPostAddressCity({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_CITY, payload);
  },
  setRealPostAddressStreet({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_STREET, payload);
  },
  setRealPostAddressHouse({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_HOUSE, payload);
  },
  setRealPostAddressBuilding({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_BUILDING, payload);
  },
  setRealPostAddressOffice({ commit }, payload) {
    commit(types.SET_REAL_POST_ADDRESS_OFFICE, payload);
  },
  setEmail({ commit }, payload) {
    commit(types.SET_EMAIL, payload);
  },
  setPassword({ commit }, payload) {
    commit(types.SET_PASSWORD, payload);
  },
  setRepeatPassword({ commit }, payload) {
    commit(types.SET_REPEAT_PASSWORD, payload);
  },
  setReturnUrl({ commit }, payload) {
    commit(types.SET_RETURN_URL, payload);
  },
  setCookie({ commit }, payload) {
    commit(types.SET_COOKIE, payload);
  },
  setSmsCode({ commit }, payload) {
    commit(types.SET_SMS_CODE, payload);
  },
  setSmsCodeValid({ commit }, payload) {
    commit(types.SET_SMS_CODE_VALID, payload);
  },
  setEmailCode({ commit }, payload) {
    commit(types.SET_EMAIL_CODE, payload);
  },
  setEmailCodeValid({ commit }, payload) {
    commit(types.SET_EMAIL_CODE_VALID, payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
  strict: true,
  namespaced: true,
};
